import * as React from 'react'
import { formatPhoneNumber } from '../utils/string-utils'

export const ContactUsSideBar: React.FC = () => (
  <div className={'contact-sidebar'} style={{ color: '#818b92' }}>
    <h2 className={'title'} style={{ color: 'black', fontSize: 26, fontWeight: 500 }}>
      NuBrakes Contact
    </h2>
    <p className={'call-us'}>Call Us</p>
    <CityContactUs cityName={'Austin'} phoneNumber={'5126402560'} />
    <CityContactUs cityName={'Dallas-Fort Worth'} phoneNumber={'4697063497'} />
    <CityContactUs cityName={'Houston'} phoneNumber={'8327064115'} />
    <CityContactUs cityName={'San Antonio'} phoneNumber={'2107946444'} />
    <CityContactUs cityName={'Atlanta'} phoneNumber={'4704677736'} />
    <CityContactUs cityName={'Nashville'} phoneNumber={'6292061979'} />
    <CityContactUs cityName={'Tampa'} phoneNumber={'8139579076'} />
    <CityContactUs cityName={'Jacksonville'} phoneNumber={'9048674476'} />
    <CityContactUs cityName={'Orlando'} phoneNumber={'6892164829'} />
    <CityContactUs cityName={'Miami'} phoneNumber={'7867802495'} />
    <CityContactUs cityName={'Chicago'} phoneNumber={'7732426985'} />
    <Headquarters />
  </div>
)
const cityNameStyles = { marginBottom: 0, color: '#818b92' }

const Headquarters = () => {
  return (
    <div>
      <p style={cityNameStyles}>
        <strong>Headquarters</strong>
      </p>
      <p style={cityNameStyles}>2028 E Ben White Blvd #240-9317</p>
      <p style={cityNameStyles}>Austin, Texas 78741</p>
    </div>
  )
}

const CityContactUs: React.FC<{ cityName: string; phoneNumber: string }> = ({ cityName, phoneNumber }) => {
  return (
    <div className={'pb-3'}>
      <p style={cityNameStyles}>
        <strong>{cityName} Brake Repair</strong>
      </p>
      <a href={`tel:${phoneNumber}`}>{formatPhoneNumber(phoneNumber)}</a>
    </div>
  )
}
